module.exports = __webpack_public_path__ + "catalog/items/simple-stair/simple-stair.png";